<template>
    <div v-show="show" class="table-container">
        <div class="tableContent">
            <p v-if="type != 'success'" class="title">批量退回</p>
            <div class="success" v-if="type == 'success'">
                <i></i>
                <p>批量通过完成</p>
            </div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div v-show="!showMessage" class="notice">
                <i></i>
                <span>以下稿件无法批量操作</span>
            </div>
            <div class="table">
                <ul class="title">
                    <li>稿件名称</li>
                    <li v-if="!showMessage">未执行原因</li>
                    <li v-if="showMessage">退回理由</li>
                </ul>

                <ul v-show="showMessage" class="edit">
                    <li v-for="(item,index) in available" :key="index">
                        <ul>
                            <li class="info">
                                <p class="title">{{item.title}}</p>
                                <div>
                                    <p>
                                        <i class="zz"></i>
                                        <span>{{item.user_name}}</span>
                                    </p>
                                    <p>
                                        <i class="platform"></i>
                                        <span>{{item.platforms}}</span>
                                    </p>
                                </div>
                            </li>
                            <li class="textarea">
                                <textarea v-model="item.content" placeholder="请填写退回理由" maxlength="100"></textarea>
                                <p class="num">{{item.num}}/100</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul v-show="!showMessage" class="content">
                    <li v-for="(item,index) in unavailable" :key="index">
                        <ul>
                            <li>{{item.title}}</li>
                            <li v-show="item.type == 'locked'">正在被<span @click="showCard(item.uid, $event)">{{item.msg}}</span>审核</li>
                            <li v-show="item.type != 'locked'">{{item.msg}}</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="btns">
                <!-- <p @click="cancel" class="btn g">返回</p> -->
                <p @click="confirm" class="btn g">确定</p>
                <p v-if="this.showMessage" @click="cancel" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
export default {
    data() {
        return {
            show: false,
            config: {},
            callback: null,
            showMessage: false,
            type: 'fail',
            available: [],
            unavailable: [],
            interval: null
        }
    },
    watch: {
        showMessage(to) {
            // console.log(to)
            if(to){
                this.$nextTick(() => {
                    let textarea = document.querySelectorAll('textarea')
                    console.log(textarea)
                    for (let index = 0; index < textarea.length; index++) {
                        const element = textarea[index];
                        element.addEventListener('input', () => {
                            this.available[index].num = this.available[index].content.length
                            this.$forceUpdate();
                        })
                    }
                })
            }else{
                this.$nextTick(() => {
                    let textarea = document.querySelectorAll('textarea')
                    for (let index = 0; index < textarea.length; index++) {
                        const element = textarea[index];
                        element.removeEventListener('input', () => {
                            this.available[index].num = this.available[index].content.length
                            this.$forceUpdate();
                        })
                    }
                })
            }
        }
    },
    methods: {
        open(config, callback) {
            this.config = config;
            this.type = config.type;
            if(this.type == 'fail'){
                this.unavailable = config.data.unavailable;
                if(this.unavailable.length==0){
                    this.showMessage = true;
                }
                if(config.data.available.length > 0){
                    config.data.available.forEach(el => {
                        el.content = ''
                        el.num = 0
                    });
                }
                this.available = config.data.available;
            }else{
                this.unavailable = config.data;
            }
            this.callback = callback;
            this.show = true;
        },
        confirm() {
            if(!this.showMessage){
                if(this.type == 'success'){
                    this.show = false;
                    this.callback(true)
                }else{
                    this.showMessage = true;
                    if(this.available.length > 0){
                        let ids = [];
                        this.available.forEach(el => {
                            ids.push(el.id)
                        })

                        let lockInfo = {
                            id: ids.join(",")
                        }

                        common
                        .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                        .then(r => {
                            if (r) {
                                this.interval = setInterval(() => {
                                    let lockInfo = {
                                        id: ids.join(",")
                                    }

                                    common
                                    .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                                    .then(r => {
                                        if (r) {
                                            
                                        }
                                    });
                                }, 30000);
                            }
                        });
                    }
                }
            }else{
                let status = true;
                this.available.forEach(el => {
                    if(!el.content){
                        status = false;
                    }
                })
                if(status) {
                    this.show = false;
                    clearInterval(this.interval);
                    this.interval = null
                    this.callback(this.available)
                }else{
                    this.$toast('退回理由不能为空')
                }
            }
        },
        cancel() {
            this.show = false;
            clearInterval(this.interval);
            this.interval = null
            this.callback(false)
        },
        close() {
            this.cancel()
        },
        showCard(id, e) {
            if (id == 0) return;

            const el = e.target;

            this.$card(id, el);
        },
    }
}
</script>

<style lang="less">
    .table-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .tableContent {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -435px;
            margin-top: -251px;
            width: 870px;
            min-height: 502px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            &>.title {
                font-size: 24px;
                line-height: 33px;
                font-weight: bold;
                color: #050F0F;
                margin-bottom: 10px;
                padding-bottom: 16px;
                border-bottom: 1px solid #DCDCDC;
                box-sizing: border-box;
            }

            &>.success {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top: 40px;
                margin-bottom: 10px;
                padding-bottom: 30px;
                border-bottom: 1px solid #DCDCDC;
                box-sizing: border-box;

                i {
                    display: block;
                    width: 50px;
                    height: 50px;
                    background-image: url('./assets/success.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-bottom: 30px;
                }

                p {
                    font-size: 20px;
                    line-height: 28px;
                    color: #050F0F;
                    font-weight: bold;
                }
            }

            .close {
                position: absolute;
                top: 30px;
                right: 30px;
                width: 21px;
                height: 21px;
            }

            .notice {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 20px 0;

                i {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background: url('./assets/notice.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 12px;
                }

                span {
                    font-size: 16px;
                    line-height: 22px;
                    color: #050F0F;
                }
            }

            .table {
                display: flex;
                flex-direction: column;

                ul.title {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    height: 38px;
                    background-color: rgba(185,195,195,0.2);
                    padding: 0 10px;
                    box-sizing: border-box;

                    li {
                        width: 50%;
                        font-size: 14px;
                        color: #829191;
                        font-weight: bold;
                    }
                }

                ul.content {
                    display: flex;
                    flex-direction: column;
                    height: 240px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 4px;
                    }

                    &>li {
                        width: 100%;
                        padding: 19px 11px;
                        box-sizing: border-box;

                        &:hover {
                            background: rgba(185, 195, 195, 0.08);
                        }

                        ul {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;

                            li {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 50%;
                                font-size: 16px;
                                line-height: 22px;
                                color: #050F0F;

                                span {
                                    color: #41B48C;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }

                ul.edit {
                    display: flex;
                    flex-direction: column;
                    height: 290px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 4px;
                    }

                    &>li {
                        width: 100%;
                        padding: 10px 0px 10px 11px;
                        border-bottom: 1px solid #F0F0F0;
                        box-sizing: border-box;

                        &:hover {
                            background: rgba(185, 195, 195, 0.08);
                        }

                        ul {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;

                            li {
                                width: 50%;
                                
                                &.info {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;

                                    .title {
                                        font-size: 16px;
                                        line-height: 22px;
                                        color: #050F0F;
                                        margin-bottom: 10px;
                                    }

                                    &>div {
                                        display: flex;
                                        flex-direction: row;
                                        align-items: center;

                                        p {
                                            display: flex;
                                            flex-direction: row;
                                            align-items: center;
                                            margin-right: 40px;

                                            span {
                                                font-size: 13px;
                                                line-height: 18px;
                                                color: #B9C3C3;
                                            }

                                            i {
                                                display: block;
                                                
                                                &.zz {
                                                    width: 16px;
                                                    height: 18px;
                                                    background: url('./assets/zz.svg') no-repeat;
                                                    background-size: 100% 100%;
                                                    background-position: center center;
                                                    margin-right: 10px;
                                                }

                                                &.platform {
                                                    width: 29px;
                                                    height: 29px;
                                                    background: url('./assets/platform.svg') no-repeat;
                                                    background-size: 100% 100%;
                                                    background-position: center center;
                                                    margin-right: 3px;
                                                }
                                            }
                                        }
                                    }
                                }

                                &.textarea {
                                    position: relative;
                                    height: 100px;
                                    background: rgba(185, 195, 195, 0.08);
                                    border-radius: 4px;
                                    padding: 10px;
                                    box-sizing: border-box;

                                    textarea {
                                        width: 100%;
                                        height: 100%;
                                        background: transparent;
                                        resize: none;

                                        &::-webkit-scrollbar {
                                            width: 4px;
                                        }
                                        &::-webkit-scrollbar-thumb {
                                            background: #ddd;
                                            border-radius: 4px;
                                        }
                                        &::placeholder {  
                                            color: #B9C3C3;
                                        }
                                    }

                                    .num {
                                        position: absolute;
                                        bottom: 6px;
                                        right: 14px;
                                        font-size: 12px;
                                        line-height: 17px;
                                        color: #829191;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }
    }
</style>